import React, { FC, memo, useMemo } from 'react'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { useSelector } from 'react-redux'
import { Button } from '@ucheba/ui/components/Button/desktop'
import Link from 'next/link'
import { eventsSimilarSelectors } from '@ucheba/store/events/similar'
import { EventsList } from '../../../../EventsList/desktop'
import { IEventsAnother } from '../types'

const EventsAnother: FC<IEventsAnother> = (props) => {
  const { pathname, eventsSearchPath } = props
  const events = useSelector(eventsSimilarSelectors.entity)?.items || []

  const allEventsHref = useMemo(() => `${eventsSearchPath}`, [eventsSearchPath])

  if (!events.length) return null

  return (
    <>
      <Heading h2='Другие мероприятия' spacing='xxsmall' />

      <Spacing spacing='xlarge' />

      <EventsList items={events} href={pathname} />

      <Spacing spacing='xlarge' />

      <Link href={allEventsHref} legacyBehavior>
        <Button block view='outline' color='blue'>
          Показать все мероприятия
        </Button>
      </Link>
    </>
  )
}

export default memo(EventsAnother)
